/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { DefinitionSource } from "./DefinitionSource";
import type { SafetyRule } from "./SafetyRule";
import type { Score } from "./Score";
import type { Stage } from "./Stage";

export interface QuestionnaireDefinition {
  schema_version: string;
  id: string;
  /** Language-independent identity; what recency keys on */
  instrument_id: string;
  title: string;
  version: string;
  language: string;
  definition_source: DefinitionSource;
  /** @pattern ^sha256:[0-9a-f]{64}$ */
  checksum: string;
  /** @exclusiveMinimum 0 */
  validity_period_days: number;
  scoring: Score[];
  /** @minItems 1 */
  stages: Stage[];
  safety_rules?: SafetyRule[];
  completion_message?: string | null;
}
